import AutoExportRuleRowMenu from "./AutoExportRuleRowMenu";
import {Tag} from "antd";

export default function autoExportRuleColumns(t) {
    return [
        {
            title: t('Id'),
            dataIndex: 'id',
            key: 'id',
            columnName: 'id',
            sorter: true,
            render: (text, record) => (
                <AutoExportRuleRowMenu row={record} />
            )
        },
        {
            title: t('Rule Name'),
            dataIndex: 'name',
            key: 'name',
            columnName: 'name',
            sorter: true,
        },
        {
            title: t('Description'),
            dataIndex: 'description',
            key: 'description',
            columnName: 'description',
            sorter: true,
            ellipsis: true,
        },
        {
            title: t('SQL Query'),
            dataIndex: 'sqlQuery',
            key: 'sqlQuery',
            columnName: 'sqlQuery',
            ellipsis: true,
            render: (text) => (
                <code style={{fontSize: '12px'}}>{text}</code>
            )
        },
        {
            title: t('Target AE Title'),
            dataIndex: 'targetAeTitle',
            key: 'targetAeTitle',
            columnName: 'targetAeTitle',
            sorter: true,
        },
        {
            title: t('Status'),
            dataIndex: 'isEnabled',
            key: 'isEnabled',
            columnName: 'isEnabled',
            sorter: true,
            render: (isEnabled) => (
                <Tag color={isEnabled ? 'green' : 'red'}>
                    {isEnabled ? t('Enabled') : t('Disabled')}
                </Tag>
            )
        },
        {
            title: t('Created At'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            columnName: 'createdAt',
            sorter: true,
            render: (text) => text ? new Date(text).toLocaleString() : '-'
        },
    ]
}
